import { useEffect, useRef } from 'react';
/**
 * @deprecated This hook is obsolete, use `useMountedState` instead
 */
var useRefMounted = function () {
    var refMounted = useRef(false);
    useEffect(function () {
        refMounted.current = true;
        return function () {
            refMounted.current = false;
        };
    }, []);
    return refMounted;
};
/**
 * @deprecated This hook is obsolete, use `useMountedState` instead
 */
export default useRefMounted;
